import { toDateStr } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { RowActions } from '../../../../../../components/table/RowActions';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { AuditMediaPlayerAction } from '../../../../components/AuditMediaPlayerAction';
import { MatchLink } from './MatchLink';
import { AudiosWithoutMatchesReport } from './types';

export function NoMatchesReportResult(p: ReportResultProps<AudiosWithoutMatchesReport>) {
  const { $t } = useIntl();
  const station = useActiveStation();

  return (
    <MrtTable
      data={p.result.items}
      muiTableBodyRowProps={({ row }) => ({
        className: row.original.sameMd5MatchedAudio ? 'table-warning' : '',
      })}
      columns={[
        {
          id: 'customId',
          header: $t({
            id: 'audit.props.customId',
            defaultMessage: 'Custom ID',
          }),
          accessorKey: 'audio.customId',
          size: 140,
        },
        {
          id: 'createdAt',
          header: $t({
            id: 'common.createdAt',
            defaultMessage: 'Creado',
          }),
          accessorKey: 'audio.createdAt',
          size: 120,
          Cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate
                value={row.original.audio.createdAt}
                day="2-digit"
                month="2-digit"
                year="2-digit"
              />
              <LTime value={row.original.audio.createdAt} />
            </div>
          ),
        },
        {
          id: 'notes',
          header: $t({
            id: 'common.notes',
            defaultMessage: 'Notas',
          }),
          Cell: ({ row }) => {
            const item = row.original;

            return (
              item.sameMd5MatchedAudio && (
                <MatchLink
                  audio={item.sameMd5MatchedAudio}
                  url={`/audit/s/${station.slug}/reports/no-matches?audio_id=${
                    item.sameMd5MatchedAudio.customId
                  }&from=${toDateStr(p.values.matchFrom)}&to=${toDateStr(p.values.matchTo)}`}
                />
              )
            );
          },
        },
        {
          header: $t({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),
          id: 'actions',
          size: 150,
          Cell: ({ row }) => (
            <RowActions>
              {row.original.audio && (
                <AuditMediaPlayerAction
                  audio={{
                    ...row.original.audio,
                    stationId: station.id,
                  }}
                />
              )}
            </RowActions>
          ),
        },
      ]}
    />
  );
}
